import StorageHelper from './StorageHelper';
import SubdominioHelper from './SubdominioHelper';
import { store } from '../store';
import axios from 'axios';

export default class SessionService {     

    static _instance = null;

    /**
     * Obtiene la instancia de la clase.
     *
     * @type {SessionService}
     */
    static get instance() {
        return this._instance ??= new SessionService();
    }
    
    _inicializado = false;

    /**
     * @type {import('vue-router').Router|null}
     */
    _router = null;

    async initialize(router) {
        if (this._inicializado) return;
        this._inicializado = true;
        this._router = router;
    }

    /**
     * Registra inicio de sesión en el localStorage.
     */
    async initSession() {
        // Inicializar datos de la sesión
        const visitedRoutes = [];
        const name = this._router.currentRoute.value.name;
        if (name === 'Home' || name === 'Categoria' || name === 'Articulo' || name === 'Promocion') {
            const fullPath = this._router.currentRoute.value.fullPath;
            const id = ['idcategoria', 'idarticu', 'idpromocion'].reduce((value, key) => value || this._router.currentRoute.value.params[key], null);
            visitedRoutes.push({
                fullPath,
                name,
                id,
                views: 1,
            });
        }
        const session = {
            iduser: store.user?.id || null,
            created_at: new Date().toISOString(),
            visitedRoutes: visitedRoutes,
            finished_at: null,
        };
        
        // Almacenar los datos de la sesión
        await StorageHelper.setJson('session', session);
    }

    /**
     * Fin de sesión y envío al servidor.
     */
    async endSession() {
        // Obtener los datos de la sesión almacenados
        const session = await StorageHelper.getJson('session');
        if (session) {
            session.finished_at = new Date().toISOString();

            // Se utiliza fetch con 'keepalive: true' en lugar de axios para asegurar que la petición se envíe
            // incluso si la página se cierra antes de que se complete la solicitud.
            try {
                fetch(axios.getUri({ url: '/registersession' }), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Approx-Client': axios.defaults.headers.common['X-Approx-Client'],
                        'X-Approx-Subdomain': await SubdominioHelper.getSubdominio(),
                    },
                    body: JSON.stringify(session),
                    keepalive: true,
                });

                // Eliminar datos de la sesión
                await StorageHelper.remove('session');
            } catch (error) {
                console.error('Error al enviar la sesión:', error);
            }
        }
    }
}